/* global CONFIGURATION */

"use strict";

const Cookies = require("js-cookie");

const isSafari = window.safari !== undefined;
const cookieOptions = {
  sameSite: "strict",
  secure: true,
  path: "/",
};

if (isSafari && CONFIGURATION && CONFIGURATION.debugOrTest) {
  delete cookieOptions["secure"];
}

const SECURE_KEY_NAME = "__Host-hint.account_token";
const INSECURE_KEY_NAME = "hint.account_token";

const keyName = window.location.protocol === "https:" ? SECURE_KEY_NAME : INSECURE_KEY_NAME;

// Sessions are recorded over https, where the token is stored under the
// __Host- prefixed name, but replayed over http, where only the bare name is
// read. A replay therefore has to look under the other name too.
const isReplayingRecordedSession = () => Boolean(window.Meticulous?.isRunningAsTest);
const alternateKeyName = keyName === SECURE_KEY_NAME ? INSECURE_KEY_NAME : SECURE_KEY_NAME;

module.exports = {
  set: function (value) {
    return Cookies.set(keyName, value, cookieOptions);
  },

  get: function () {
    if (isReplayingRecordedSession()) {
      return Cookies.get(keyName) || Cookies.get(alternateKeyName);
    }

    return Cookies.get(keyName);
  },

  remove: function () {
    Cookies.remove(keyName, cookieOptions);

    if (isReplayingRecordedSession()) {
      Cookies.remove(alternateKeyName, cookieOptions);
    }
  },
};
